import { createSlice } from "@reduxjs/toolkit";

export interface BrokerToCustomerDialog {
  isOpen: boolean;
}

const initialState: BrokerToCustomerDialog = {
  isOpen: false,
};

const brokerToCustomerDialog = createSlice({
  name: "brokerToCustomerDialog",
  initialState: initialState,
  reducers: {
    openDialog: (state) => {
      state.isOpen = true;
    },
    closeDialog: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openDialog, closeDialog } = brokerToCustomerDialog.actions;

export default brokerToCustomerDialog;
